import React from 'react';
import { Button, Col, message, Row, Select } from 'antd';

import { renderSpecTableHeaderCell } from './index';

import { 
	_getCategorySpecTableSortingRules,
	_postCategorySpecTableSortingRules 
} from '../../../services';

const Option = Select.Option;

class SpecTableSortingRules extends React.Component{

	render = () => {

		const { sortingRules } = this.state;
		const { specTableHeaders } = this.props;

		return (
			<div>
				<Row type="flex" gutter={8} align="middle">
					
					<Col>
						<h4>
							Sorting Rules:
						</h4>
					</Col>

					<Col>
						<Button onClick={ this.handleAddEmptySortingRule } icon="plus-square">Add</Button>
					</Col>

					<Col>
						<Button onClick={ this.handleSaveSortingRules } type="primary" icon="save">Save</Button>
					</Col>
					

				</Row>

				{/* sortingRules */}
				{
					sortingRules.map(
						(sortingRule,i) => {

							let sortText = "Sort By:";

							if ( i > 0) {
								sortText = "Then By:"
							}

							return (
								<Row key={i} style={{ marginTop: 8 }} type="flex" gutter={8} align="middle">
									<Col>{sortText}</Col>
									<Col>
										<Select 
											value={ sortingRule.sortByHeader && parseInt(sortingRule.sortByHeader, 10) } 
											onChange={ (value) => this.handleSelectSortingRule({ field:"sortByHeader", value, index: i }) } 
											style={{ width: 200 }}>

											{specTableHeaders.map(
												(headerCell, i) => ( <Option value={ i }>{ renderSpecTableHeaderCell( headerCell ) }</Option> )
											)}

										</Select>
									</Col>

									<Col>
										<Select 
											value={ sortingRule.sortDirection } 
											onChange={ (value) => this.handleSelectSortingRule({ field:"sortDirection", value, index: i }) } 
											style={{ width: 200 }}>

											<Option value={"asc"}>Ascending (1, 2, 3 ...)</Option>
											<Option value={"desc"}>Descending (3, 2, 1 ...)</Option>

										</Select>
									</Col>

									<Col>
										<Button onClick={ () => this.handleDeleteSortingRule( i ) } type="danger" ghost icon="close"/>
									</Col>
								</Row>
							)

						}
					)
				}

			</div>
		)
	}

	constructor( props ){
		super(props);

		this.state = {
			sortingRules: []
		};

		this.sortingRuleObject = {
			sortByHeader: '',
			sortDirection: ''
		}

	}

	componentDidMount = () => {

		_getCategorySpecTableSortingRules( this.props.subKebabCase )
			.then( res => {
				this.setState({ sortingRules: res.data.sortingRules });
			})	

	}
	
	handleAddEmptySortingRule = () => {
		this.setState({
			sortingRules: [
				...this.state.sortingRules,
				this.sortingRuleObject
			]
		})
	}

	handleDeleteSortingRule = ( index ) => {
		this.setState({
			sortingRules: this.state.sortingRules.filter( ( a,i ) => i !== index )
		})
	}

	handleSelectSortingRule = ({ field, value, index }) => {

		this.setState({

			sortingRules: this.state.sortingRules.map( ( sortingRule, i ) => {

				if( i !== index ){
					return sortingRule;
				}

				return {
					...sortingRule,
					[field]: value
				}

			})

		})

	}

	handleSaveSortingRules = () => {
		
		let loadingMsg = message.loading("Saving sorting rules..");

		const { sortingRules } = this.state;

		_postCategorySpecTableSortingRules({ subKebabCase: this.props.subKebabCase, sortingRules })
			.then( res => {

				loadingMsg();

				message.success("Saved new sorting rules!");
				
				// _postSaveSortingRule
			})
	}
	
}

export default SpecTableSortingRules;


// WEBPACK FOOTER //
// ./src/components/category/category-specs/spec-table-sorting-rules.js